const reactSelectStyles: any = {
  control: (styles: StyleSheet) => ({
    ...styles,
    borderRadius: '0.5rem',
    border: '1px solid #D0D5DD',
    borderColor: 'rgb(208 213 221 / var(--tw-border-opacity))',
    background: '#ffffff',
    boxShadow: 'none',
    fontSize: '',
    fontWeight: 400,
    ':focus': {
      borderColor: '#085ccc',
    },
    ':hover': {
      borderColor: '#e5e7eb',
    },
    height: '100%',
  }),
  indicatorSeparator: (styles: StyleSheet) => ({
    width: 0,
  }),
  multiValue: (styles: StyleSheet) => ({
    ...styles,
    backgroundColor: '#ffffff',
    border: '1px solid #D0D5DD',
    borderRadius: '6px',
    color: '#344054',
    fontSize: '14px',
    maxWidth: 140,
  }),
  multiValueRemove: (styles: StyleSheet) => ({
    ...styles,
    color: '#000000',
    ':hover': {
      background: '#ffffff',
    },
  }),
  option: (
    styles: StyleSheet,
    { isSelected, isFocused }: { isSelected: boolean; isFocused: boolean },
  ) => ({
    ...styles,
    background: isSelected ? '#dddddd' : isFocused ? '#EDEFF1' : '#FFFFFF',
    margin: '6px 0',
    color: isSelected ? '#fff' : '#1f2938',
    ':hover': {
      background: isSelected ? `${'#dddddd'}` : '#EDEFF1',
    },
  }),
  placeholder: (styles: StyleSheet) => ({
    ...styles,
    whiteSpace: 'nowrap',
    color: '',
    fontWeight: 'normal',
  }),
}

export default reactSelectStyles
